<main data-qa="forbidden-page">
  <div class="page-layout">
    <div class="content">
      <h1>403</h1>
      <div class="main-text">
        <div>
          <div class="heading">
            <div class="icon">
              <app-icon
                icon="information"
                iconSize="64"
              ></app-icon>
            </div>
            <div class="text">Not Permitted</div>
          </div>
          <p class="description-text">You don't have access to this page.</p>
          <div class="description">
            @if (helpLinkUrl$ | async; as helpLinkUrl) {
              <p class="mt-3 description-text">
                Please
                <a
                  [href]="helpLinkUrl"
                  target="_blank"
                  >contact support</a
                  >
                  if you believe this is an error.
                </p>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
